<app-progress-nav
  class="nav-bar"
  [totalSteps]="pageNumbers.length"
></app-progress-nav>
<app-weight
  *ngIf="pageNumbers.includes(1)"
  class="main"
  id="1Page"
  [pageNumber]="pageNumbers.indexOf(1) + 1"
  [currentPageNumber]="currentStep"
  [type]="'start'"
></app-weight>
<app-activity-level
  *ngIf="pageNumbers.includes(2)"
  class="main"
  id="2Page"
  [needCalculate]="generateShared.goal ? true : false"
  [pageNumber]="pageNumbers.indexOf(2) + 1"
  [currentPageNumber]="currentStep"
></app-activity-level>
<app-vegetarian
  *ngIf="pageNumbers.includes(3)"
  class="main"
  id="3Page"
  [pageNumber]="pageNumbers.indexOf(3) + 1"
  [currentPageNumber]="currentStep"
></app-vegetarian>
<app-disease
  *ngIf="pageNumbers.includes(4)"
  class="main"
  id="4Page"
  [pageNumber]="pageNumbers.indexOf(4) + 1"
  [currentPageNumber]="currentStep"
></app-disease>
<app-hated-foods
  *ngIf="pageNumbers.includes(5)"
  class="main"
  id="5Page"
  [pageNumber]="pageNumbers.indexOf(5) + 1"
  [currentPageNumber]="currentStep"
></app-hated-foods>
<app-difficulty
  *ngIf="pageNumbers.includes(6)"
  class="main"
  id="6Page"
  [pageNumber]="pageNumbers.indexOf(6) + 1"
  [currentPageNumber]="currentStep"
></app-difficulty>
<app-start-date
  *ngIf="pageNumbers.includes(7)"
  class="main"
  id="7Page"
  [pageNumber]="pageNumbers.indexOf(7) + 1"
  [currentPageNumber]="currentStep"
></app-start-date>
<app-date
  *ngIf="pageNumbers.includes(8)"
  class="main"
  id="8Page"
  [pageNumber]="pageNumbers.indexOf(8) + 1"
  [currentPageNumber]="currentStep"
  [type]="'pregnancy'"
></app-date>
<app-date
  *ngIf="pageNumbers.includes(9)"
  class="main"
  id="9Page"
  [pageNumber]="pageNumbers.indexOf(9) + 1"
  [currentPageNumber]="currentStep"
  [type]="'breastfeeding'"
></app-date>
<app-fasting-days
  *ngIf="pageNumbers.includes(10)"
  class="main"
  id="10Page"
  [pageNumber]="pageNumbers.indexOf(10) + 1"
  [currentPageNumber]="currentStep"
></app-fasting-days>
<app-submit-button [title]="buttonTitle"></app-submit-button>
<app-popup *ngIf="showPopup" [input]="popupInputModel"></app-popup>
<app-loading *ngIf="showLoading"></app-loading>
